import React, { useState, useEffect, useRef } from "react";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_URL = `${BASE_URL}admin/getdata/insert_banner.php`;
const IMG_URL = `${BASE_URL}img/banner/`;

export default function Slideshow() {
  const [slides, setSlides] = useState([]);
  const [current, setCurrent] = useState(0);
  const slideshowTimer = useRef(null);

  /* =========================
     FETCH BANNERS
  ========================== */
  const fetchBanners = async () => {
    try {
      const res = await axios.get(API_URL);
      setSlides(res.data || []);
    } catch (err) {
      console.error("Banner fetch failed", err);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  /* =========================
     AUTO SLIDE
  ========================== */
  useEffect(() => {
    if (!slides.length) return;

    startAutoSlide();
    return () => stopAutoSlide();
  }, [current, slides]);

  const startAutoSlide = () => {
    stopAutoSlide();
    slideshowTimer.current = setTimeout(goNext, 5000);
  };

  const stopAutoSlide = () => {
    if (slideshowTimer.current) {
      clearTimeout(slideshowTimer.current);
    }
  };

  const goNext = () => {
    setCurrent((prev) => (prev + 1) % slides.length);
  };

  const goPrev = () => {
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToSlide = (index) => {
    setCurrent(index);
    stopAutoSlide();
  };

  /* =========================
     EMPTY STATE
  ========================== */
  if (!slides.length) {
    return <div className="slideshow">No banners available</div>;
  }

  return (
    <div className="slideshow">
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`slide parallax-top ${
            index === current ? "slide--current" : "slide--hidden"
          }`}
        >
          <figure className="slide__figure">
            <div className="slide__figure-inner">
              <div
                className="slide__figure-img"
                style={{
                  backgroundImage: `url(${IMG_URL + slide.image})`,
                }}
              />
              <div className="slide__figure-reveal"></div>
            </div>
          </figure>
        </div>
      ))}

      {/* Navigation */}
      <nav className="arrow-nav fade-top">
        <button
          className="arrow-nav__item arrow-nav__item--prev"
          onClick={goPrev}
        >
          ‹
        </button>

        <button
          className="arrow-nav__item arrow-nav__item--next"
          onClick={goNext}
        >
          ›
        </button>
      </nav>

      {/* Title & TOC */}
      <nav className="nav fade-top" style={{ position: "absolute" }}>
        <button className="nav__button"></button>
        <h2 className="nav__chapter">{slides[current].title}</h2>

        <div className="toc">
          {slides.map((slide, i) => (
            <button
              key={slide.id}
              className={`toc__item ${i === current ? "active" : ""}`}
              onClick={() => goToSlide(i)}
            >
              <span className="toc__item-title">{slide.title}</span>
            </button>
          ))}
        </div>
      </nav>

      {/* Indicator */}
      <div className="slideshow__indicator">
        {current + 1} / {slides.length}
      </div>
    </div>
  );
}
